<template>
    <div v-if="activity"
         class="activity"
         :style="`background-image: url('${absolute_preview_url}')`"
         :class="`type-${activity.type} ${has_uploads ? 'has-uploads' : ''}`">
        <div class="inner"
             @click="show()"
             style="background-image: url('https://via.placeholder.com/240x240?text=PREVIEW')">
            <div class="title">
                <h6>{{ activity.name }}</h6>
                <div class="info">Activity</div>
            </div>

            <icon-check v-if="has_uploads" class="check" size="18" />

        </div>

        <modal :id="utils.randomId({prefix: 'modal'})"
               v-if="show_modal"
               :show="true"
               size="xl"
               @close="close()">
            <template #title>
                {{ activity.name }}
            </template>

            <div class="preview-content">
                <div class="row d-flex align-items-stretch">
                    <div class="col-md-8">
                        <iframe v-if="activity.data?.file && activity.data?.file?.mime === 'application/pdf'"
                                :src="uploads.url( activity.data.file.url ) + '#toolbar=1'"
                                frameborder="0"></iframe>
                        <img v-else-if="preview_url" class="img-fluid mb-3"
                             :src="`${preview_url ? uploads.url( preview_url ) : 'https://via.placeholder.com/240x240?text=PREVIEW+NOT+AVAILABLE'}`" alt="">
                    </div>
                    <div class="col-md-4">

                        <markdown-text :content="activity.data.description" />

                        <template v-if="activity?.data?.type === 'link' && activity?.data?.url">
                            <h5>External Link</h5>
                            <a target="_blank" :href="activity?.data?.url">
                                {{ utils.ellipsis(activity?.data?.url) }}
                            </a>
                        </template>

                        <template v-if="activity?.data?.student_instructions">
                            <h5>Instructions</h5>
                            <markdown-text :content="activity.data.student_instructions" />
                        </template>

                    </div>
                </div>
            </div>


<!-- Upload files directly from activity -->
<!--            <hr class="my-3">-->

<!--            <h5>Upload your Deliverable</h5>-->
<!--            <file-uploader v-model="uploaded" />-->

            <template #footer>
<!--                <button type="button"-->
<!--                        v-if="is_admin"-->
<!--                        @click="removeElement()"-->
<!--                        class="btn btn-danger mr-auto">Remove From Canvas</button>-->
                <a v-if="activity.data.file"
                   :href="uploads.url( activity.data.file.url )"
                   target="_blank"
                   type="button"
                   class="btn btn-primary mr-auto">Download Activity</a>
            </template>
        </modal>
    </div>
</template>

<script>
import API from "@/API";
import Modal from "@/Components/Common/Modal";
import MarkdownText from "@/Components/Common/MarkdownText";
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import FileUploader from "@/Components/Common/FileUploader";
import {mapActions} from "vuex";
import IconCheck from "@/Icons/IconCheck";

export default {
    name: "CanvasActivity",
    components: {IconCheck, Modal, MarkdownText, FileUploader},
    props: ['element', 'inPath', 'inCanvas', 'canvas', 'fragmentPrefix', 'stage', 'section'],
    emits: ['upload'],
    mixins: [utils, uploads],

    data(){
        return {
            // activity: null,
            show_modal: false,
        }
    },


    computed: {


        options(){
            return this.activity?.data?.options;
        },

        activity(){
            return this.element.element;
        },

        upload_fragment_key(){
            return `canvas_${this.fragmentPrefix}_activity_${this.element.id}_upload`;
        },

        canvas_uploads_fragment_key(){
            return `canvas_upload_${this.stage}_${this.section.id}`;
        },

        canvas_uploads(){
            if( this.canvas?.fragments[ this.canvas_uploads_fragment_key ] ){
                return this.canvas.fragments[ this.canvas_uploads_fragment_key ].filter(u => u.activity_id && u.activity_id === this.element.id);
            }
            return [];
        },

        has_uploads(){
            return this.canvas_uploads.length > 0;
        },

        /**
         * @deprecated
         */
        uploaded: {
            get(){
                return this.canvas?.fragments[ this.upload_fragment_key ];
            },
            set(val){
                this.canvas.fragments[ this.upload_fragment_key ] = val;
                this.$emit('upload', {element: this.element, upload: val});
                this.save();
            }
        },

        is_removable_from_canvas(){
            /**
             * Removable if element does not exists in path or if it exists more than once.
             */
            return (! this.inPath) || (this.inCanvas > 1);
        },

        is_uploaded(){
            return false;
        },


        absolute_preview_url(){

            let url = 'https://via.placeholder.com/480x480?text=PREVIEW+NOT+AVAILABLE';
            let w = 300;
            let h = 300;

            if( this.options?.width ){
                w = h * parseInt(this.options?.width);
            }

            if( this.preview_url ){
                url = this.uploads.image( this.uploads.url( this.canvas_preview_url ), {w, h} );
            }

            return url;

        },

        canvas_preview_url(){
            if( this.uploaded?.preview_url ) return this.uploaded.preview_url;
            return this.preview_url;
        },

        preview_url(){
            if( this.activity.data?.preview_url ) return this.activity.data?.preview_url;
            if( this.activity.data?.preview_file?.preview_url ) return this.activity.data?.preview_file?.preview_url;
            if( this.activity.data?.file?.preview_url ) return this.activity.data?.file?.preview_url;
            return null;
        },
    },

    methods: {

        ...mapActions('repositories', ['updateRepository']),

        show(){
            this.show_modal = true;
        },
        close(){
            this.show_modal = false;
        },

        removeElement(){
            confirm('Are you sure to remove it from Canvas?');
            this.$emit('remove-canvas-element');
            this.show_modal = false;
        },

        removeUpload(){
            confirm('Are you sure to remove the uploaded file from Canvas?');
            this.$emit('remove-upload');
        },

        save(){
            const fragments = {};
            fragments[ this.upload_fragment_key ] = this.uploaded;
            this.updateRepository({scope: this.canvas.scope, fragments});
        }

    },

    async mounted() {
        // console.log( this.activity );
    }
}
</script>

<style lang="scss" scoped>
.activity{
    background: #6c7275 no-repeat center / cover;
    border: #FFFFFF solid 2px;
    border-radius: 6px;
    padding: 100% 0 0;
    cursor: pointer;
    width: 100%;
    position: relative;
    box-shadow: 0 2px 8px #00000029;

    .has-uploads{

    }
}

.aw-1{
    .activity{
        padding-top: 100%;
    }
}

.aw-2{
    .activity{
        padding-top: 50%;
    }
}
.aw-3{
    .activity{
        padding-top: 33.333333%;
    }
}
.aw-4{
    .activity{
        padding-top: 25%;
    }
}
.aw-5{
    .activity{
        padding-top: 20%;
    }
}

.title{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1rem;
    color: white;

    h6{
        padding: 0.5rem;
        background: rgba(white, 0.7);
        display: inline-block;
        border-radius: 0.3rem;
        color: $dark;
        backdrop-filter: blur(3px);
    }
}

@media (min-width: 650px) and (max-width: 1199px){
    .aw-1{
        .activity{
            padding-top: 0%;
            padding-bottom: 100%;
        }
    }

    .aw-2{
        .activity{
            padding-top: 0%;
            padding-bottom: 50%;
        }
    }
    .aw-3{
        .activity{
            padding-top: 33.333333%;
            padding-bottom: 33.333333%;
        }
    }
    .aw-4{
        .activity{
            padding-top: 25%;
            padding-bottom: 25%;
        }
    }
    .aw-5{
        .activity{
            padding-top: 20%;
            padding-bottom: 20%;
        }
    }


    .title{
        position: static;
        z-index: 1;
        padding: 1rem;

        h6{
            background: rgba(white, 0.7);
            padding: 0.5rem;
            display: inline-block;
            border-radius: 0.3rem;
            color: $dark;
            backdrop-filter: blur(3px);
        }
    }
}



.sortable-ghost{
    .activity{
        background: rgba($dark, 0.3);
        border-color: $dark;
        > * {
            opacity: 0.5;
        }
    }
}

.info{
    position: absolute;
    background: $primary;
    color: white;
    bottom: 0;
    left: 0;
    border-radius: 0 0.4rem 0 0.4rem;
    padding: 0.2rem 0.5rem;
    text-transform: uppercase;
}

iframe{
    width: 100%;
    height: 75vh;
}

.check{
    position: absolute;
    top: 0.3rem;
    right: 0.3rem;
    background: $success;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: rgba($dark, 0.1) 0 1px 3px;
}

</style>
